<template>
  <div class="leaderboard container" id="million-bit-leaderboard">
    <h1 class="pt-3 honk-text">Leaderboard</h1>
    <div class="btn-group btn-block">
        <button type="button" class="btn btn-icon btn-block btn-primary my-3" v-on:click="toggleView()" v-bind:class="{'disabled': leaderboardView === 'pixels'}">
            Pixels
        </button>
        <button type="button" class="btn btn-icon btn-block btn-primary my-3" v-on:click="toggleView()" v-bind:class="{'disabled': leaderboardView === 'clicks'}">
            Clicks
        </button>
    </div>
    <div class="leaderboard-wrap mb-5">
    <table style="width: 100%;" v-if="leaderboardView === 'pixels'">
      <tr v-for="team in teams" v-bind:key="team._id">
        <td>
          <h2 class="mr-1 honk-text">{{ team.rank }}</h2>
        </td>
        <td class="text-left">
          <h4 v-text="team.team.name"></h4>
        </td>
        <td class="text-left">
          <span v-for="seq in team.seqs" v-bind:key="seq.hash">
            <a v-bind:href="seq.url" target="_blank" v-lazy-load>
              <img :data-url="s3Base+seq.hash+'-crop.jpeg'" class="" />
            </a> 
          </span>
        </td>
        <td class="text-right pixel-count">
          <h5 class="mr-2">{{ team.pixels }} pixels</h5>
        </td>
      </tr>
    </table>
    <table style="width: 100%;" v-if="leaderboardView === 'clicks'">
      <tr v-for="(click, i) in clicks" v-bind:key="click._id">
        <td>
          <h2 class="mr-1 honk-text">{{ i + 1 }}</h2>
        </td>
        <td class="text-left">
          <a v-bind:href="click.url" target="_blank" v-lazy-load>
            <img :data-url="s3Base+click.hash+'-crop.jpeg'" class="" />
          </a>
        </td>
        <td class="text-left">
          <a v-bind:href="click.url" target="_blank">
            {{ click.url }}
          </a>
        </td>
      </tr>
    </table>
    </div>
  </div>
</template>

<script>
const BASE_S3_BUCKET_TRX = process.env.BASE_S3_BUCKET_TRX;
const BASE_S3_BUCKET = process.env.BASE_S3_BUCKET;
export default {
  name: 'leaderboard',
  data () {
    return {
      leaderboardView: 'pixels',
      teams: [{"team":{"_id":"66c43fe72ccc6c5a634a7b42","name":"ShibaPunkz"},"pixels":26368,"seqs":[{"seq":18,"url":"https://t.me/ShibaPunkzisBased","hash":"0xdcdd6ddd5cdde1ba96d4bf08d293c9bd32bc7b68ffa2ebbef373850a729a9e60"},{"seq":17,"url":"https://shibapunkz.art","hash":"0x68858170cd1780e88d7de85ee1de3424a420affdc91fc7a08a856dca223f75a9"},{"seq":19,"url":"https://x.com/luckycharmspunk?s=21&t=LNn5RtgixeELpaAbERLC8w","hash":"0xa020ccd9986bbcd414ed151da1d57c265a73b8922447a1ba69c6a13cebe27595"},{"seq":20,"url":"https://x.com/Arcturus_TA","hash":"0x0949b678a576d45cfc6a340b422e5da1e4ac632ea591b01a1f511300c4f39856"},{"seq":21,"url":"https://x.com/WenMoonSer420","hash":"0xad07f85e92a2d874c01e90da199c221d1485707917fafc878d1041708d411eed"},{"seq":22,"url":"https://x.com/MrMeffU?t=D5srtuS1sAdZ_v_ZwogZyA&s=09","hash":"0x934ba5e6e6b27672428de6ebeacc327acdb69b5ca40eb979147e8387b7268a54"},{"seq":23,"url":"https://x.com/TobiNckl","hash":"0x4e1a732a058ddf447a1f7eeb8ab2ac5492122ffe11ad090c28bd8075c541e657"},{"seq":25,"url":"https://ibb.co/1QfnnCM","hash":"0xdb6ca1560842b0426a206fd9300e9b938ea8c578f64385a8552f7985be14c479"},{"seq":24,"url":"https://x.com/cryptoclown85","hash":"0xe452bd1f3addddad1fd469a5e2e8627ac18c7ff05149e36b559c6efe8ed8eccd"},{"seq":28,"url":"https://t.me/ShibaPunkzisBased","hash":"0xd275eaa9cf3927c13a472403ee4297d110aaa2a675bfe12f2076f81913fe0875"},{"seq":29,"url":"https://x.com/b_t_furfoot","hash":"0x8eda96fedd37a8e2b972efb41bfdc294a3c81918ac0ecf77705208d93a51d281"},{"seq":33,"url":"https://x.com/WenMoonSer420","hash":"0xd6d5dbe22ce7a57ae804378ec76ed84b33a87546d22a8dc941bbbbc06a2af975"},{"seq":34,"url":"https://x.com/WenMoonSer420","hash":"0x5c4de12bf767f21090ef86fb09215cfd42ddc04c6b43e75ef7b4c908d5417848"},{"seq":35,"url":"https://t.me/ShibaPunkzisBased","hash":"0xcfd29ba76de65ae36c0f2806e6c55946cf450e694cdc8d40864b5d81b729bf03"},{"seq":36,"url":"https://magiceden.io/collections/base/0x5a0e41fff63659f64a9e328eaaf81183bf9e43cd?activeTab=items","hash":"0xc47fbaa7a4a0b7812557b28386b1ee3a837c52f9c00618822c9bb87234762bbc"},{"seq":56,"url":"https://t.me/ShibaPunkzisBased","hash":"0xa3ebbc879e2350981069b3fb844d08051b5196a3849dd8fc92ebe9ce797ba9d7"}],"rank":1},{"team":{"_id":"66c43fe72ccc6c5a634a7b43","name":"Froggi"},"pixels":8192,"seqs":[{"seq":30,"url":"https://froggi.app","hash":"0x0b8d1bdb03b16bf88030a935e84e0f5f125c324cd0f6554c971ca798f2ed4d61"},{"seq":31,"url":"https://froggi.app","hash":"0x96ac83e54a8e051eccd9956b5844b346d4302bba1dfab0e143a9fddf17d76e03"}],"rank":2},{"team":{"_id":"66c43fe72ccc6c5a634a7b44","name":"Fungi"},"pixels":5120,"seqs":[{"seq":32,"url":"https://fungifungi.art/","hash":"0xc654f4f789f44a7b275f90ffc984155d33641c2cd031128633203f882df5a776"},{"seq":37,"url":"https://inscriptions.market/","hash":"0x53d31d646cf5881d0b0e94b855e21e23658a7eac9af22c73ef0822e162c9f710"}],"rank":3},{"team":{"_id":"66c43fe72ccc6c5a634a7b46","name":"All Your Base"},"pixels":4096,"seqs":[{"seq":39,"url":"https://www.belongtous.xyz/","hash":"0x774c599a3872142161fb36f9511128811421e01a41f3d7a4636f83b51fae48e8"}],"rank":4},{"team":{"_id":"66c43fe72ccc6c5a634a7b47","name":"Late Night on Base"},"pixels":4096,"seqs":[{"seq":40,"url":"https://x.com/latenightonbase","hash":"0x796269e9a5aff885d10b557de4e0c777910f809c6699d9162718d101842c5549"}],"rank":5},{"team":{"_id":"66c43fe72ccc6c5a634a7b45","name":"Friendo"},"pixels":4096,"seqs":[{"seq":41,"url":"https://www.friendocoin.com/","hash":"0x280a7bc19acebc55afa68699e5d93a04e5a393d3883e3ad32dd3861dd2d17ba3"}],"rank":6},{"team":{"_id":"66c43fe72ccc6c5a634a7b48","name":"Gems of Base"},"pixels":4096,"seqs":[{"seq":47,"url":"https://gemsofbase.com","hash":"0x84f4689509ec537e4ba1779cd652a448bf5395cb41cec1713ee6e45b5b69772c"}],"rank":7},{"team":{"_id":"66c43fe72ccc6c5a634a7b4e","name":"Nascent"},"pixels":3072,"seqs":[{"seq":62,"url":"https://www.nascent.xyz/","hash":"0xbb09cc6f7bd85c1404560a23b99f1c822a92109e2c38bdd5dda697c48bada308"}],"rank":8},{"team":{"_id":"66c43fe72ccc6c5a634a7b49","name":"Base Bulls"},"pixels":2560,"seqs":[{"seq":45,"url":"https://x.com/BaseBullsNFT","hash":"0x5605445207a0f3438e3015213d55ee938fcaafd80710c3b26e9f239b9a0d3bf0"},{"seq":46,"url":"https://t.me/BaseBullsNFT","hash":"0x1ac455abf4165fff1adfa33ad2a07a57e978937d8d32f4f9eda8e343ed927063"}],"rank":9},{"team":{"_id":"66c43fe72ccc6c5a634a7b4d","name":"Balt on Base"},"pixels":2304,"seqs":[{"seq":15,"url":"https://x.com/Balt_on_base","hash":"0x11145fa24ea7cfc40a5eaa5d67e9a6f001d5baf9e1b1e2c37aaeb9d0de2e8d09"}],"rank":10},{"team":{"_id":"66c43fe72ccc6c5a634a7b4c","name":"Memgen"},"pixels":2304,"seqs":[{"seq":49,"url":"https://www.memgen.io/","hash":"0xafe0fcb216b72110ac2a24b39a9f56b019c0c4af36e840597b8bc2d0b67cbe95"}],"rank":11},{"team":{"_id":"66c43fe72ccc6c5a634a7b4b","name":"Based Chad"},"pixels":2304,"seqs":[{"seq":53,"url":"https://basedchad.io","hash":"0xdbc8e4c5b9c7af56f8ee3ee705f14d04a9b887baaa0fec8bedfad01de43c9930"}],"rank":12}],
      clicks: [],
      s3Base: BASE_S3_BUCKET_TRX,
      dataSrc: BASE_S3_BUCKET+'leaderboard.json?'+Date.now(),
      dataSrcClicks: BASE_S3_BUCKET+'clicks.json?'+Date.now(),
    }
  },
  inject: ['updateAppRoute'],
  created: function () {
    this.updateAppRoute('list');
    axios.get(this.dataSrc)
      .then((response) => {
        this.teams = response.data;
      });
  },
  methods: {
    toggleView: async function() {
      this.leaderboardView = this.leaderboardView === 'pixels' ? 'clicks' : 'pixels';
      if (this.clicks.length === 0) {
        await this.fetchClicks();
      }
    },
    fetchClicks: async function() {
      return new Promise((resolve, reject) => {
        axios.get(this.dataSrcClicks)
          .then((response) => {
            this.clicks = response.data;
            resolve();
          });
      });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  img.external-link {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }
  #million-bit-transactions {
    background: #fff !important;
  }
  #million-bit-transactions table tr td.link {
    overflow-wrap: anywhere;
  }
  .leaderboard-wrap {
    border: 5px solid #0063cd;
    border-radius: 8px;
  }
  .leaderboard-wrap table tr {
    background: #000000;
    color: #ffffff;
  }
  .leaderboard-wrap table tr:nth-child(even) {
    background: #1e1e1e;
  }
  .leaderboard .links ul {
    margin: 0 0;
    list-style: none;
  }
  .pixel-count {
    color: gray;
  }
  h2.mr-1.honk-text {
    margin: 32px 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Leaderboard.vue?945a8296